import { useFlow, FLOWS } from "hook/register/flow/useFlow";
import React, { useState } from "react";
import RegisterSection from "./register_section";
import RegisterVerify from "./register_verify";
import { Button, Divider } from "antd";
import { LeftOutlined } from "@ant-design/icons";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const RegisterForm = ({ setTab }) => {
  // -------------------------- VAR -----------------------------
  const { flow } = useFlow();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderRegister = () => {
    const isRegister = flow === FLOWS.REGISTER;
    if (!isRegister) return null;
    return <RegisterSection />;
  };

  const renderVerify = () => {
    const isVerify = flow === FLOWS.VERIFY;
    if (!isVerify) return null;
    return <RegisterVerify />;
  };

  // -------------------------- MAIN ----------------------------
  return (
    <React.Fragment>
      <Button
        className="absolute left-5 top-5"
        shape="circle"
        size="middle"
        icon={<LeftOutlined />}
        onClick={() => setTab("login")}
      />
      <p>Để đăng nhập bằng Email xin vui lòng điền thông tin dưới đây</p>
      {renderRegister()}
      {renderVerify()}
    </React.Fragment>
  );
};
export default RegisterForm;
